class App {
  constructor() {
    this.preDefinedApps = {
      YOUTUBE: "YouTube",
      USB: "Media"
    }
  }
  _init = async () => {
    return true
  }

  getList = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.APPS}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.APPS,
      CmdType: "Request",
      Fun: "ApplicationControl",
      CommandDetails: {
        RequestListOfAvailableApplications: {
          Filter: ["Native", "NonNative"]
        }
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else
      return payload.detail.CurrentAvailableApplicationList.map(app => {
        return { key: app.ApplicationName, value: app.ApplicationName }
      })
  }
  launch = async app_id => {
    let requestObject_ = {
      Cookie: __._api.cookies.APP,
      CmdType: "Change",
      Fun: "ApplicationControl",
      CommandDetails: {
        ApplicationDetails: {
          ApplicationName: app_id
        },
        ApplicationState: "Activate"
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  close = async (app_id = null) => {
    let requestObject_ = {
      Cookie: __._api.cookies.APP,
      CmdType: "Change",
      Fun: "ApplicationControl",
      CommandDetails: {
        ApplicationDetails: {
          ApplicationName: app_id || __.app.isLaunched
        },
        ApplicationState: "Deactivate"
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
}

export default App
